// Room config – images loaded dynamically, info/pricing defined here

const numSort = (a, b) => {
  const n = (s) => parseInt(String(s).replace(/\D/g, "") || "0", 10);
  return n(a) - n(b);
};

const royalCtx    = require.context("../assets/Rooms/Royal Suite",   false, /\.(png|jpe?g|webp|gif)$/i);
const familyCtx   = require.context("../assets/Rooms/Family Room",   false, /\.(png|jpe?g|webp|gif)$/i);
const platinumCtx = require.context("../assets/Rooms/Platinum king", false, /\.(png|jpe?g|webp|gif)$/i);
const premiumCtx  = require.context("../assets/Rooms/Premium Twin",  false, /\.(png|jpe?g|webp|gif)$/i);
const superCtx    = require.context("../assets/Rooms/Super Delux",   false, /\.(png|jpe?g|webp|gif)$/i);
const cottageCtx  = require.context("../assets/Rooms/Cottage",      false, /\.(png|jpe?g|webp|gif)$/i);

const load = (ctx) => ctx.keys().sort(numSort).map(ctx);

// Shared services for all rooms
export const SERVICES_INCLUDED = [
  "Complimentary breakfast for night staying guests with standard occupancy",
  "Swimming pool access",
  "High-speed Wi-Fi Internet",
  "Under 04 year's child accommodation is complementary with family",
  "Country Boating facility, Kids Zone & Playground",
];

export const SERVICES_EXCLUDED = [
  "Extra Mattress BDT 1,500/-++ per bed",
  "Food additional charges free order and availability basis",
  
];

export const CHECKIN_POLICY = [
  "Check-in Time: 02:00 PM | Check-out Time: 12:00 Noon",
  "Early check-in and late check-out subject to availability – 50% (half-day)  room charge applicable",
];

export const ROOMS = [
  {
    name: "Royal Suite",
    slug: "royal-suite",
    images: load(royalCtx),
    noOfRooms: 1,
    pax: 4,
    rate: "16,000",
    previousRate: "20,240",
    description:
      "Experience ultimate luxury in our signature Royal Suite. Crafted for discerning guests, this expansive suite features premium furnishings, a private seating area, and breathtaking resort views — perfect for families seeking an unforgettable retreat.",
  },
  {
    name: "Family Suite",
    slug: "family-suite",
    images: load(familyCtx),
    noOfRooms: 4,
    pax: 3,
    rate: "8,500",
    previousRate: "10,735",
    description:
      "Designed with families in mind, the Family Suite offers generous space, warm interiors and modern amenities. Ideal for a cozy stay with loved ones amid the lush surroundings of Chuti Resort Purbachal.",
  },
  {
    name: "Platinum King",
    slug: "platinum-king",
    images: load(platinumCtx),
    noOfRooms: 3,
    pax: 2,
    rate: "7,500",
    previousRate: "9,487",
    description:
      "The Platinum King offers an exclusive king-bed experience with refined décor and premium comfort. Perfect for couples looking for a romantic escape in a serene natural setting.",
  },
  {
    name: "Premium Twin",
    slug: "premium-twin",
    images: load(premiumCtx),
    noOfRooms: 11,
    pax: 2,
    rate: "7,000",
    previousRate: "8,855",
    description:
      "Our most popular room type, the Premium Twin is thoughtfully designed for comfort and convenience. Featuring twin beds, modern amenities, and garden views — a great choice for friends or colleagues.",
  },
  {
    name: "Super Deluxe",
    slug: "super-deluxe",
    images: load(superCtx),
    noOfRooms: 3,
    pax: 2,
    rate: "6,500",
    previousRate: "8,222",
    description:
      "The Super Deluxe room blends style and value beautifully. A welcoming retreat for two, offering all essential comforts in a tastefully decorated space surrounded by nature.",
  },
  {
    name: "Wooden Cottage",
    slug: "cottage",
    images: load(cottageCtx),
    noOfRooms: 8,
    pax: 2,
    rate: "10,000",
    previousRate: "12,650",
    description:
      "Our cottages offer a private, home-like stay surrounded by greenery—ideal for guests who want extra space and tranquility. Each cottage is comfortably furnished for two, with the same warm hospitality and resort facilities you enjoy across Chuti Resort Purbachal.",
  },
];

export const getRoomBySlug = (slug) => ROOMS.find((r) => r.slug === slug);
